import { QRCodeSVG } from "qrcode.react";
import { Printer, Star, Phone, MapPin, Wrench, ShoppingBag } from "lucide-react";

// Jul-2026 (User-Wunsch) — Druckbarer QR-Flyer für Vito Vespa (führt auf /vito-vespa).
export default function VitoVespaFlyerPage() {
    const url = `${window.location.origin}/vito-vespa`;
    return (
        <div className="min-h-screen bg-gray-200 py-10 print:bg-white print:py-0" data-testid="vito-flyer-page">
            <div className="max-w-[148mm] mx-auto mb-4 flex justify-end gap-2 print:hidden">
                <a href={`${process.env.REACT_APP_BACKEND_URL}/api/public/vito/pitch.pdf`} target="_blank" rel="noreferrer"
                   className="inline-flex items-center gap-2 bg-[#C1443C] text-white px-5 py-2 rounded-full font-bold hover:bg-[#a83831]"
                   data-testid="vito-pitch-pdf-btn">
                    Pitch-PDF öffnen
                </a>
                <button onClick={() => window.print()}
                        className="inline-flex items-center gap-2 bg-[#2B2B2B] text-white px-5 py-2 rounded-full font-bold hover:bg-black"
                        data-testid="vito-flyer-print-btn">
                    <Printer className="w-4 h-4" /> Flyer drucken
                </button>
            </div>
            {/* A5-Flyer */}
            <div className="mx-auto bg-[#FAF3E0] text-[#2B2B2B] shadow-2xl print:shadow-none flex flex-col"
                 style={{ width: "148mm", minHeight: "210mm", fontFamily: "Georgia, 'Times New Roman', serif" }}
                 data-testid="vito-flyer-sheet">
                <div className="bg-[#9FD8CB] px-8 pt-10 pb-8 text-center">
                    <p className="uppercase tracking-[0.35em] text-xs font-bold text-[#2B2B2B]/70">Vito Vespa · Berlin-Spandau</p>
                    <h1 className="text-4xl italic mt-3 leading-tight">Dolce Vita<br />auf zwei Rädern.</h1>
                    <p className="mt-3 text-sm">Eine echte Vespa. Bei einem echten Italiener.*</p>
                </div>
                <div className="flex-1 px-8 py-8 flex flex-col items-center text-center">
                    <div className="bg-white p-4 rounded-sm shadow" data-testid="vito-flyer-qr">
                        <QRCodeSVG value={url} size={180} fgColor="#2B2B2B" bgColor="#FFFFFF" />
                    </div>
                    <p className="mt-3 text-xs text-[#4a4a4a]">QR-Code scannen → Showroom, Werkstatt &amp; Shop online</p>
                    <div className="grid grid-cols-3 gap-3 mt-8 w-full text-xs">
                        <div className="bg-white rounded-sm p-3"><ShoppingBag className="w-5 h-5 mx-auto text-[#C1443C]" /><p className="font-bold mt-1">Showroom &amp; Shop</p><p className="mt-1 text-[#4a4a4a]">Vespas + Teile &amp; Zubehör online</p></div>
                        <div className="bg-white rounded-sm p-3"><Wrench className="w-5 h-5 mx-auto text-[#C1443C]" /><p className="font-bold mt-1">Meister-Werkstatt</p><p className="mt-1 text-[#4a4a4a]">Service, Restauration, Tuning</p></div>
                        <div className="bg-white rounded-sm p-3"><Star className="w-5 h-5 mx-auto text-amber-400 fill-amber-400" /><p className="font-bold mt-1">4,7 / 5 Sterne</p><p className="mt-1 text-[#4a4a4a]">45 Google-Rezensionen</p></div>
                    </div>
                </div>
                <div className="bg-[#2B2B2B] text-[#FAF3E0] px-8 py-6 text-center text-sm">
                    <p className="flex items-center justify-center gap-2"><MapPin className="w-4 h-4 text-[#9FD8CB]" /> Nonnendammallee 32 · 13599 Berlin (U7 Paulsternstr.)</p>
                    <p className="flex items-center justify-center gap-2 mt-1"><Phone className="w-4 h-4 text-[#9FD8CB]" /> 0172 3920299 · Mo–Fr 10–18 Uhr · Sa 10–14 Uhr</p>
                    <p className="mt-3 text-[9px] opacity-50">* Demo-Entwurf von TwoWheels — Aussagen vor Druck mit dem Händler abstimmen.</p>
                </div>
            </div>
        </div>
    );
}
